import React from 'react';

const PlusSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M11.5 2v9.5H2v1h9.5V22h1v-9.5H22v-1h-9.5V2z" />
    </svg>
);

PlusSvg.displayName = 'PlusSvg';
export default PlusSvg;
